import React from 'react';
import { useTranslation } from 'react-i18next';

import ListResource from './ListResource.jsx';
import { env } from '../../config';

const ListSchools = () => {
  const { i18n: { language } } = useTranslation();
  const lang = language === 'en' ? 'en' : 'zhhk';
  return (
  <ListResource
    {...{
      searchable: true,
      api: '/api/core/schools',
      sort: { 'title.zhhk': 1 },
      actions: { remove: false },
      cols: [
        { key: 'title.zhhk', children: '名稱', sortable: true },
        { key: 'title.en', children: 'Name', sortable: true },
        {
          key: 'district',
          sortable: true,
          getter: (v) => env.districts[v][lang],
        },
        {
          key: 'stage',
          sortable: true,
          getter: (v) => (
            {
              p: { en: 'Primary', zhhk: '小學' },
              s: { en: 'Secondary', zhhk: '中學' },
            }[v][lang]),
        },
        {
          key: 'studentCount',
          children: lang === 'en' ? 'Students' : '學生人數',
          sortable: true,
          getter: (v) => v || 0,
        },
      ],
    }}
  />
  );
};

export default ListSchools;
